<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :autoUpdate="autoUpdate" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import message from "../../utils/message";
    import request from "@/utils/axios.js";
    export default {
        name: "Order",
        components: {CommonTable},
        data(){
            return{
                autoUpdate: true,
                searchs:[
                    {
                        name: 'orderName',
                        placeholder: '订单名称',
                        type: 'input'
                    },{
                        name: 'orderNo',
                        placeholder: '订单号',
                        type: 'input'
                    },
                    {
                        name: 'outTradeNo',
                        placeholder: '外部订单号',
                        type: 'input'
                    },
                    {
                        name: 'siteId',
                        placeholder: '网站',
                        type: 'select',
                        selectUrl: '/siteInfo/getAll',
                        selectValue: []
                    },
                    {
                        name: 'status',
                        placeholder: '订单状态',
                        type: 'select',
                        selectValue:[
                            {
                                key: "1",
                                value: "成功"
                            },
                            {
                                key: "4",
                                value: "未处理"
                            },{
                                key: 5,
                                value: '处理中'
                            },{
                                key: 6,
                                value: '关闭'
                            }
                        ]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'order:add',
                    update: 'order:update',
                    delete: 'order:delete',
                    deleteBatch: 'order:deleteBatch'
                },
                url: {
                    get: '/order/listByCondition',
                    add: '/order/add',
                    update: '/order/update',
                    delete: '/order/delete/',
                    delete_batch: '/order/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: false,
                    width: '75',
                    detail: true,
                },{
                    field: 'orderName',
                    label: '订单名称',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'orderNo',
                    label: '订单号',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'outTradeNo',
                    label: '外部订单号',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'orderInfo',
                    label: '订单信息',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'money',
                    label: '订单金额',
                    show: {
                        type: 'money'
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'earnings',
                    label: '订单佣金',
                    show: {
                        type: 'money'
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                    detail: false,
                    width: '',
                },{
                    field: 'orderTypeId',
                    label: '订单分类',
                    selectUrl: '/orderType/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'siteId',
                    label: '网站名称',
                    selectUrl: '/siteInfo/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'business',
                    label: '商户账号',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '成功',
                            type: 'success'
                        },{
                            key: 4,
                            value: '未处理',
                            type: 'info'
                        },{
                            key: 5,
                            value: '处理中',
                            type: 'warning'
                        },{
                            key: 6,
                            value: '关闭',
                            type: 'danger'
                        }]
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'callback',
                    label: '回调地址',
                    detail: true,
                    width: '',
                },{
                    field: 'url',
                    label: '凭证图片地址',
                    detail: {
                        type: 'link'
                    },
                    width: '',
                },{
                    field: 'failCause',
                    label: '失败原因',
                    detail: true,
                    width: '',
                },{
                    field: 'updateNick',
                    label: '修改人',
                    detail: true,
                    width: '',
                },{
                    field: 'grabTime',
                    label: '抢单时间',
                    show: true,
                    width: '',
                },{
                    field: 'completeTime',
                    label: '完成时间',
                    detail: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加订单',
                    updateTitle: '修改订单',
                    labelWidth: '105px',
                    model: [{
                        field: 'orderName',
                        label: '订单名称：',
                        type: 'input',
                        placeholder: '订单名称',
                        rules:[{required: true, message: '请输入订单名称', trigger: 'blur'}],
                        add: true,
                        update: true,
                    }, {
                        field: 'outTradeNo',
                        label: '外部订单号：',
                        type: 'input',
                        placeholder: '外部订单号',
                        rules:[{required: true, message: '请输入外部订单号', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'orderInfo',
                        label: '订单信息：',
                        type: 'input',
                        placeholder: '订单信息',
                        rules:[/*{required: true, message: '请输入订单信息', trigger: 'blur'}*/],
                        add: true,
                        update: true,
                    },{
                        field: 'money',
                        label: '订单金额：',
                        type: 'input',
                        placeholder: '订单金额',
                        rules:[{required: true, message: '请输入订单金额', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'earnings',
                        label: '订单佣金：',
                        type: 'input',
                        placeholder: '订单佣金',
                        rules:[{required: true, message: '请输入订单佣金', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'orderTypeId',
                        label: '订单分类：',
                        type: 'select',
                        placeholder: '请选择',
                        rules:[{required: true, message: '请选择订单分类', trigger: 'blur'}],
                        selectUrl: '/orderType/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                    },{
                        field: 'callback',
                        label: '回调地址：',
                        type: 'input',
                        placeholder: '回调地址',
                        rules:[],
                        add: true,
                        update: true,
                    }],
                },
                operate: [{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '置为成功',
                    handle: (row) => {
                        console.log(row);
                        if (row.status != 4){
                            message.warning("订单的状态不可置为成功");
                            return;
                        }
                        request.post({
                            url: '/order/status',
                            data: {id: row.id,status:1},
                            confirm: '确定置为成功？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    }
                },{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '关闭订单',
                    handle: (row) => {
                        if (row.status != 4){
                            message.warning("订单的状态不可关闭");
                            return;
                        }
                        request.post({
                            url: '/order/status',
                            data: {id: row.id,status:6},
                            confirm: '确定关闭订单？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("订单关闭成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("订单关闭失败");
                                }
                            }
                        });
                    }
                }],
            }
        }
    }
</script>

<style scoped>

</style>
